import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

const VisaType = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaTypes, setVisaTypes] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if visa types data is available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('visaTypesData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setVisaTypes(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('visaTypesData');
                fetchVisaTypes();
            }
        } else {
            // If no cache, fetch data from the API
            fetchVisaTypes();
        }
    }, []);

    const fetchVisaTypes = async () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        try {
            const response = await axios.get(`${apiBaseUrl}${Url}`);
            const newData = response.data;

            // Save the fetched data along with the current timestamp in localStorage
            localStorage.setItem('visaTypesData', JSON.stringify({
                data: newData,
                timestamp: Date.now(),
            }));
            setVisaTypes(newData);
        } catch (error) {
            console.error("Error fetching API", error);
        }
    };

    return (
        <div className="most-countries pb-90">
            <div className="container px-1">
                <div className="mb-25">
                    <h1 className={'text-center py-5 fw-bold text-uppercase'}>
                        <i className={'fa fa-passport'}></i> work visas from us !!!
                    </h1>
                </div>
                <div className="row">
                    {visaTypes.map((visaType, index) => {
                        return (
                            <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-6 mb-30" key={index}>
                                <Link className="text-decoration-none" to={`/visa/${visaType.slug}`}>
                                    <div className="countries-item img-top rounded-3 bg-primary-subtle">
                                        <div className="countries-item__top">
                                            <div className="countries-item__top-img">
                                                <img className={'rounded-circle'} src={`${backendBaseUrl}${visaType?.image}`} alt={visaType?.name} />
                                            </div>
                                        </div>
                                        <div className="countries-item__bottom text-center d-flex justify-content-center align-items-center">
                                            <div className="text-center">
                                                <h6 className="fw-bold text-dark">
                                                    {visaType?.name}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default VisaType;
